const GA_LOADED_FLAG = '__ngGaLoaded'

export function loadGoogleAnalytics() {
  if (typeof window === 'undefined') return

  const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID
  if (!measurementId || window[GA_LOADED_FLAG]) return

  window[GA_LOADED_FLAG] = true

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  function gtag() {
    window.dataLayer.push(arguments)
  }
  window.gtag = gtag
  gtag('js', new Date())
  gtag('config', measurementId, { anonymize_ip: true })
}